// src/utils/agencyValidation.js

/**
 * 代理店フォームのバリデーションを実行
 * @param {Object} agencyForm - 代理店フォームのデータ
 * @param {string} agencyForm.name - 代理店名
 * @param {string} agencyForm.accountname - アカウント名（メールアドレス）
 * @returns {Object} バリデーション結果 { isValid: boolean, errors: string[] }
 */
export const validateAgencyForm = (agencyForm) => {
  const errors = [];
  const { name, accountname } = agencyForm;

  // 代理店名チェック
  if (!name?.trim()) {
    errors.push('代理店名を入力してください。');
  }

  // アカウント名チェック
  if (!accountname?.trim()) {
    errors.push('アカウント名（メールアドレス）を入力してください。');
  }

  return {
    isValid: errors.length === 0,
    errors: errors
  };
};

/**
 * バリデーション結果を表示する共通関数（alert版）
 * @param {Object} validationResult - validateAgencyForm の戻り値
 * @param {Function} displayMethod - エラー表示方法（デフォルトはalert）
 * @returns {boolean} バリデーション成功の場合 true
 */
export const displayAgencyValidationErrors = (validationResult, displayMethod = alert) => {
  if (!validationResult.isValid) {
    displayMethod(validationResult.errors.join('\n'));
    return false;
  }
  return true;
};

/**
 * バリデーション結果をErrorDialogで表示する関数（useErrorDialogと連携）
 * @param {Object} validationResult - validateAgencyForm の戻り値
 * @param {Function} showError - useErrorDialog から取得したshowError関数
 * @returns {boolean} バリデーション成功の場合 true
 */
export const displayAgencyValidationErrorsWithDialog = (validationResult, showError) => {
  if (!validationResult.isValid) {
    showError({
      message: validationResult.errors.join('\n'),
      type: 'VALIDATION_ERROR',
      // statusCodeを明示的に422（バリデーションエラー）に設定
      statusCode: 422,
      error: {
        type: 'VALIDATION_ERROR',
        code: 'AGENCY_VALIDATION_FAILED'
      }
    });
    return false;
  }
  return true;
};

/**
 * バリデーション結果をグローバルErrorDialogで表示する関数（グローバル関数使用）
 * @param {Object} validationResult - validateAgencyForm の戻り値
 * @returns {boolean} バリデーション成功の場合 true
 */
export const displayAgencyValidationErrorsGlobal = (validationResult) => {
  if (!validationResult.isValid) {
    // 動的インポートでshowGlobalErrorDialogを取得（循環参照を避けるため）
    import('../providers/ErrorDialogProvider').then(({ showGlobalErrorDialog }) => {
      showGlobalErrorDialog({
        message: validationResult.errors.join('\n'),
        type: 'VALIDATION_ERROR',
        // statusCodeを明示的に422（バリデーションエラー）に設定
        statusCode: 422,
        error: {
          type: 'VALIDATION_ERROR',
          code: 'AGENCY_VALIDATION_FAILED'
        }
      });
    });
    return false;
  }
  return true;
};